<div mat-dialog-content>
  <p>Are you sure you want to push this item to production?</p>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="yesClick()">Ok</button>
  <button mat-button (click)="cancelClick()">Cancel</button>
</div>